import { render, staticRenderFns } from "./HowToIntroducePicker.vue?vue&type=template&id=65bb6fd2"
import script from "./HowToIntroducePicker.vue?vue&type=script&lang=js"
export * from "./HowToIntroducePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports